<template>
  <b-modal
      id="list-record-catch-gallery-modal"
      ref="list-record-catch-gallery-modal"
      hide-footer
      centered
      size="lg"
      title="Képek megtekintése"
  >
    <b-overlay :show="loading">
      <b-carousel
          id="carousel-interval"
          controls
          indicators
      >
        <b-carousel-slide v-for="image in galleryData" :key="image.id" :img-src="image.downloadUrl"/>
      </b-carousel>
    </b-overlay>
  </b-modal>
</template>

<script>

import {BCarousel, BCarouselSlide, BOverlay } from 'bootstrap-vue';

export default {
  props: {
    entityId: {
      required: true
    }
  },
  components: {
    BCarousel,
    BCarouselSlide,
    BOverlay
  },
  data() {
    return {
      galleryData: [],
      loading: false
    }
  },
  methods: {
    initGallery() {

      this.galleryData = []
      this.loading = true

      this.$store.dispatch('getImagesForRecordCatch', {
        id: this.entityId,
      }).then(async response => {
        let tmp = []

        Object.keys(response.data.images).forEach(key => {
          console.log(response.data.images, key, response.data.images[key])
          tmp.push(response.data.images[key])
        })

        console.log(tmp)

        this.galleryData = tmp

      }).catch(error => {
        if (error.response.status === 422) {
          this.$refs.simpleRules.setErrors(error.response.data.errors)
        } else {
          this.$helpers.showErrorToast(error.toString())
        }
      }).finally(() => {
        this.loading = false
      })
    }
  },
  watch: {
    entityId: {
      handler() {
        this.initGallery()
      }
    }
  },
}
</script>
